var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneReceiverSilhouette(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-receiver-silhouette 1",
    clipPath: "url(#clip0_743_102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9553 15.3121C17.6263 14.1754 16.2776 13.4869 14.9649 14.6219L14.181 15.3078C13.6075 15.8058 12.5412 18.1324 8.41853 13.3899C4.29669 8.65332 6.74953 7.91583 7.32389 7.42217L8.11203 6.73534C9.41786 5.59778 8.92506 4.16574 7.98325 2.69164L7.4149 1.79876C6.46879 0.328086 5.43855 -0.637768 4.12928 0.498076L3.42185 1.11622C2.84319 1.53776 1.22571 2.90799 0.833357 5.51107C0.361162 8.63443 1.85072 12.2111 5.26341 16.1355C8.6718 20.0616 12.0089 22.0336 15.1701 21.9993C17.7972 21.9709 19.3838 20.5612 19.88 20.0487L20.59 19.4297C21.8958 18.2947 21.0845 17.1391 19.7546 15.9998L18.9553 15.3121Z",
    fill: "#666666"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneReceiverSilhouette);
export default __webpack_public_path__ + "static/media/phone-receiver-silhouette.9a1c325bfd3502ea9a5fba52b772c31b.svg";
export { ForwardRef as ReactComponent };